import { render, staticRenderFns } from "./AboutSwiper5.vue?vue&type=template&id=0e861e34&scoped=true&"
import script from "./AboutSwiper5.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper5.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper5.vue?vue&type=style&index=0&id=0e861e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e861e34",
  null
  
)

export default component.exports